import React, { useState } from 'react';
import { Card } from '../shared/Card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
export const ExerciseTrends = () => {
  const [activeExercise, setActiveExercise] = useState('bench');
  const exercises = [{
    id: 'bench',
    name: 'Bench Press'
  }, {
    id: 'squat',
    name: 'Squat'
  }, {
    id: 'deadlift',
    name: 'Deadlift'
  }];
  // Mock data for exercise progress
  const benchData = [{
    date: 'Jan',
    weight: 135
  }, {
    date: 'Feb',
    weight: 140
  }, {
    date: 'Mar',
    weight: 145
  }, {
    date: 'Apr',
    weight: 145
  }, {
    date: 'May',
    weight: 150
  }, {
    date: 'Jun',
    weight: 155
  }];
  const getExerciseData = () => {
    switch (activeExercise) {
      case 'bench':
        return {
          data: benchData,
          increase: 15,
          color: '#3b82f6' // blue
        };
      case 'squat':
        return {
          data: benchData.map(d => ({
            ...d,
            weight: d.weight * 1.5
          })),
          increase: 20,
          color: '#10b981' // green
        };
      case 'deadlift':
        return {
          data: benchData.map(d => ({
            ...d,
            weight: d.weight * 1.8
          })),
          increase: 25,
          color: '#f59e0b' // amber
        };
      default:
        return {
          data: [],
          increase: 0,
          color: '#3b82f6'
        };
    }
  };
  const {
    data,
    increase,
    color
  } = getExerciseData();
  // Custom tooltip for the chart
  const CustomTooltip = ({
    active,
    payload,
    label
  }) => {
    if (active && payload && payload.length) {
      return <div className="bg-white p-2 border border-gray-200 rounded-md shadow-sm" data-id="element-1339">
          <p className="font-medium" data-id="element-1340">{label}</p>
          <div className="flex items-center" data-id="element-1341">
            <div className="w-3 h-3 rounded-sm mr-2" style={{
            backgroundColor: color
          }} data-id="element-1342"></div>
            <p className="font-semibold" data-id="element-1343">{payload[0].value} lbs</p>
          </div>
        </div>;
    }
    return null;
  };
  return <Card className="p-4" data-id="element-1344">
      <h2 className="font-medium text-lg mb-4" data-id="element-1345">Exercise Trends</h2>
      <div className="flex overflow-x-auto space-x-2 py-2 mb-4" data-id="element-1346">
        {exercises.map(exercise => <button key={exercise.id} onClick={() => setActiveExercise(exercise.id)} className={`px-4 py-2 rounded-full whitespace-nowrap ${activeExercise === exercise.id ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700'}`} data-id="element-1347">
            {exercise.name}
          </button>)}
      </div>
      <div className="flex items-center mb-4" data-id="element-1348">
        <h3 className="font-medium" data-id="element-1349">
          {exercises.find(e => e.id === activeExercise)?.name}:
        </h3>
        <span className="ml-2 text-green-500 font-medium" data-id="element-1350">
          +{increase}% in last 6 months
        </span>
      </div>
      <div className="h-64 w-full" data-id="element-1351">
        <ResponsiveContainer width="100%" height="100%" data-id="element-1352">
          <LineChart data={data} margin={{
          top: 10,
          right: 10,
          left: 10,
          bottom: 20
        }} data-id="element-1353">
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" data-id="element-1354" />
            <XAxis dataKey="date" axisLine={false} tickLine={false} label={{
            value: 'Month',
            position: 'insideBottom',
            offset: -15,
            style: {
              textAnchor: 'middle',
              fill: '#6b7280',
              fontSize: 12
            }
          }} data-id="element-1355" />
            <YAxis axisLine={false} tickLine={false} tickCount={5} label={{
            value: 'lbs',
            angle: -90,
            position: 'insideLeft',
            style: {
              textAnchor: 'middle',
              fill: '#6b7280',
              fontSize: 12
            }
          }} tick={{
            fontSize: 12,
            fill: '#6b7280'
          }} data-id="element-1356" />
            <Tooltip content={<CustomTooltip data-id="element-1358" />} data-id="element-1357" />
            <Line type="monotone" dataKey="weight" stroke={color} strokeWidth={3} dot={{
            r: 4,
            strokeWidth: 2,
            fill: 'white'
          }} activeDot={{
            r: 6
          }} animationDuration={1500} data-id="element-1359" />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-1360">
        <div className="flex items-center" data-id="element-1361">
          <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3 text-green-600" data-id="element-1362">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1363">
              <path d="M18 15l-6-6-6 6" data-id="element-1364" />
            </svg>
          </div>
          <div data-id="element-1365">
            <p className="text-sm text-gray-600" data-id="element-1366">
              Your strength is consistently improving. Keep up the good work!
            </p>
          </div>
        </div>
      </div>
    </Card>;
};